@if (isLoading$ | async) {
  <div class="loader">
    <app-loader></app-loader>
  </div>
}
<div mat-dialog-title>
  <h2>{{ 'clientDialog.create' | translate }}</h2>
  <div class="dialog__buttons">
    <button type="button"
            class="secondary-button"
            mat-dialog-close>
      {{ 'shared.cancel' | translate }}
    </button>
    <button type="submit"
            class="primary-button"
            cdkFocusInitial
            (click)="addClient()">
      {{ 'shared.save' | translate }}
    </button>
  </div>
</div>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ 'clientDialog.client' | translate }}</mat-label>
    <input matInput placeholder="New Client Name" [(ngModel)]="name" />
  </mat-form-field>
</mat-dialog-content>
